import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TraderDashboard = _resolveComponent("TraderDashboard")!
  const _component_MerchantDashboard = _resolveComponent("MerchantDashboard")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.store.getters.isTrader || _ctx.store.getters.isTraderOperator)
      ? (_openBlock(), _createBlock(_component_TraderDashboard, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.store.getters.isMerchant || _ctx.store.getters.isMerchantOperator)
      ? (_openBlock(), _createBlock(_component_MerchantDashboard, { key: 1 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1))
  ], 64))
}